import Filter from "../Filter/Filter";
import Input from "../Input-new/Input";
import React from "react";
import SearchPanel from "../SearchPanel";
import Control from "../Control";
import '../Filter/Filter.scss';

export default class TenantListFilter extends Filter {
    constructor(props) {
        super(props);
    }

    render() {
        const {query, paneIndex} = this.state;
        const panes = [
            (
                <React.Fragment>
                    <div className={`form-title dark`}>Tenant</div>
                    <Input theme='dark'
                           valueType='text'
                           name='NAME'
                           label='Name'
                           value={query.NAME}
                           required
                           handleParentChange={this.handleChange}
                    />
                </React.Fragment>
            ),
        ];

        return (
            <div ref='main' className='Filter'>
                <div className='Filter_content'>
                    {this.props.children}
                </div>
                <SearchPanel ref='searchPanel'>
                    <nav className='Filter_nav'>
                        <div className='Filter_button' onClick={this.close}>Close</div>
                    </nav>

                    <form className='form' onSubmit={this.handleSubmit}>
                        <div className='form-slider'>
                            {
                                panes.map((el, key) => (
                                    <Control key={key} onClick={(key) => this.setState({paneIndex: key})}>
                                        <div className={`form-slider-icon dark${key === paneIndex ? ' active' : ''}`}/>
                                    </Control>
                                ))
                            }
                        </div>
                        {
                            panes[paneIndex]
                        }
                        <div className='filter-buttons'>
                            <button type='button' className='button-new negative dark' onClick={this.clear}>Clear</button>
                            <button className='button-new positive'>Apply</button>
                        </div>
                    </form>
                </SearchPanel>
            </div>
        );
    }
}